import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {

    const [lastUpdated, setLastUpdated] = useState('');
    const [, setSinceLastUpdated] = useState('');
    const [version, setVersion] = useState('');
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const fetchLastCommitDate = async () => {
            try {
                const response = await fetch('https://api.github.com/repos/Bonelab/normative-2.0-webapp/commits/production', {
                    headers: {
                        'Authorization': `token ${process.env.REACT_APP_GITHUB_TOKEN}`
                    }
                }).then(res => res.json());
                const lastCommitDate = new Date(response.commit.committer.date);

                const formattedDate = new Intl.DateTimeFormat('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                    // hour: 'numeric',
                    // minute: 'numeric',
                    // hour12: true
                }).format(lastCommitDate);

                setLastUpdated(formattedDate);

                // Calculate the time since the last commit
                const now = new Date();
                const diffTime = Math.abs(now - lastCommitDate);
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
                const diffSeconds = Math.floor((diffTime % (1000 * 60)) / 1000);

                if (diffDays > 0) {
                    setSinceLastUpdated(`${diffDays} day${diffDays > 1 ? 's' : ''} ago`);
                } else if (diffHours > 0) {
                    setSinceLastUpdated(`${diffHours} hour${diffHours > 1 ? 's' : ''} ago`);
                } else if (diffMinutes > 0) {
                    setSinceLastUpdated(`${diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`);
                } else {
                    setSinceLastUpdated(`${diffSeconds} second${diffSeconds > 1 ? 's' : ''} ago`);
                }

                const tag = await fetch('https://api.github.com/repos/Bonelab/normative-2.0-webapp/tags', {
                    headers: {
                        'Authorization': `token ${process.env.REACT_APP_GITHUB_TOKEN}`
                    }
                }).then(res => res.json());
                setVersion(tag ? tag[0]?.name : '');

            } catch (error) {
                console.error('Error fetching the last commit date:', error);
            }
        };

        fetchLastCommitDate();
    }, []);
    return (
        <div className='bg-normative-dark-panel'>
            {/* Beta disclaimer. TODO: Remove on production */}
            {/* <div className='px-10 py-5 text-sm bg-normative-black text-white text-center'>
                <p className='text-center text-red-600'>This is a beta version of the Normative platform. Please report any issues to <a href='mailto:skboyd@ucalgary.ca' className='text-normative-blue hover:underline'>skboyd@ucalgary.ca</a> or <a href='https://bonelab.ca/' target='_blank' rel='noopener noreferrer' className='text-normative-blue hover:underline'>visit our website</a> for more information.</p>
                <p>Normative is currently undergoing a public testing. Some features may be missing or not working. Thank you for your patience.</p>
                <div className='pt-2'>Last updated: {lastUpdated} <span className='text-sm text-gray-400'>{`${sinceLastUpdated}`}</span></div>
                <div className='text-xs'><span className='text-sm text-gray-400'>{`${version}`}</span></div>
            </div> */}
            <div className='flex flex-col justify-center p-10 gap-3'>
                <div className='flex flex-col gap-2 md:flex-row justify-between'>
                    <div className='flex flex-col gap-3 md:w-1/2'>
                        <Link className='w-40' to='/'>
                            <img src='/logo/normative-light.svg' alt='Normative Logo' />
                        </Link>
                        <p className='text-white text-sm'>Normative is a research platform developed by the Bone Imaging Laboratory at the University of Calgary to help researchers analyze HR-pQCT & DXA scans with reference data, percentile rankings, and detailed reports.</p>
                        <div className='flex flex-col'>
                            <span className='text-gray-500 text-xs'>
                                Need assistance? Email us at <a href='mailto:info@normative.ca' className='text-gray-400 hover:underline'>info@normative.ca</a>
                            </span>
                        </div>
                    </div>
                    <div className="flex gap-3 md:gap-5 lg:gap-10 ">
                        <div className='flex flex-col gap-1 text-sm'>
                            <h3 className='text-white md:text-lg font-semibold'>Resources</h3>
                            <Link to='/features' className='text-white hover:underline'>Features</Link>
                            <Link to='/faq' className='text-white hover:underline'>FAQ</Link>
                            <Link to='/documentation' className='text-white hover:underline'>Documentation</Link>
                        </div>
                        <div className='flex flex-col gap-1 text-sm'>
                            <h3 className='text-white md:text-lg font-semibold'>Company</h3>
                            <Link to='/about' className='text-white hover:underline'>About</Link>
                            <a href='https://bonelab.ca/' target='_blank' rel='noopener noreferrer' className='text-white hover:underline'>Bone Imaging Laboratory</a>
                        </div>
                    </div>

                </div>
                <hr className='border-gray-500'/>
                <div className="flex flex-col md:flex-row justify-between gap-2">
                    <div className="flex flex-col">
                        <p className='text-gray-500 text-sm'>© {currentYear} Normative. All rights reserved.</p>
                        <p className='text-gray-500 text-xs'>Normative was developed by the <a href="https://bonelab.ca" target='_blank' rel="noreferrer" className='underline'>Bone Imaging Lab</a></p>
                    </div>
                    <div className="flex flex-col items-start md:items-end">
                        <Link to='/terms-of-service' className='text-gray-500 text-sm underline'>Terms of Service</Link>
                        <div className='text-xs text-gray-500'>Last updated: {lastUpdated} | {`${version}`}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
